
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coding-for-kids/grade-4-5",
      function () {
        return require("private-next-pages/coding-for-kids/grade-4-5.tsx");
      }
    ]);
  